import questionnaireService from "./questionnaireService";

const surveyService = [
    ...questionnaireService
]

export default surveyService;